import { Scene } from "../types";

/**
 * A scene has three possibilities:
 * 1. Has never been rendered before or has been but doesn't have jsonUrl so is empty. Return undefined
 * 2. Has been rendered before with an old extension version so updatedAt will be null. Return null
 * 3. Has been rendered and contains updatedAt. return updatedAt
 * @param name of scene
 * @returns
 */
export const getUpdatedAt = (scene: Scene): undefined | null | string => {
  if (!scene?.jsonUrl) return undefined;
  if (!scene?.updatedAt) return null;
  else return scene?.updatedAt;
};
